import styled from 'styled-components'

export const Container = styled.div<{ maxHeight: number }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    font-size: 14px;

    & .formula-editor {
        display: flex;
        flex: 1;
        padding: 14px;
        min-height: 200px;
        max-height: ${({ maxHeight }) => `${maxHeight}px`};
    }

    & .ProseMirror {
        flex: 1;
        align-self: stretch;
        overflow-y: auto;
        line-height: 28px;
    }

    /* tiptap Placeholder extension only provides classes/attrs; it needs CSS to actually show text */
    & .ProseMirror p.is-editor-empty:first-child::before,
    & .ProseMirror p.is-empty:first-child::before,
    & .ProseMirror .is-editor-empty:first-child::before,
    & .ProseMirror .is-empty:first-child::before {
        content: attr(data-placeholder);
        float: left;
        color: var(--color-gray-400);
        pointer-events: none;
        height: 0;
    }

    &.ProseMirror-separator {
        position: relative;
        z-index: 1;
    }

    & .current-value {
        background-color: var(--color-green-100);
        color: var(--color-green-500);
        border-radius: 4px;
        padding: 0 2px;
    }
`

export const Content = styled.div`
    background-color: var(--color-gray-50);
`

export const FormulaEditorHeader = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 6px;
`
